<template>
    <div>
      <h1>공지 페이지</h1>
    </div>
  </template>
